import { Component, OnInit, Inject, ViewChild, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { WarningComponent } from '../warning/warning.component';
import { map, first } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { UploadMultiFileComponent } from '../upload-multi-file/upload-multi-file.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { UploadMultiFileAttachmentsComponent } from 'src/app/modules/dashboard/home/home-enterprise/document/add-document/upload-multi-file-attachments/upload-multi-file-attachments.component';

/**
 * File attachment component.
 */
@Component({
  selector: 'app-file-attach',
  templateUrl: './file-attach.component.html',
  styleUrls: ['./file-attach.component.scss']
})
export class FileAttachComponent implements OnInit {

  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChild(UploadMultiFileAttachmentsComponent, { read: UploadMultiFileAttachmentsComponent, static: false }) uploadMultiFileAttachmentsComponent;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onNoClick();
  }

  /**
   * variable check form change
   */
  isFormChanging = false;

  show = true;

  /**
   * array clone data
   */
  cloned = [];

  newUploadContractAttachments: any[];

  initUploadFileSize: number;
  // Title of error message upload duplicate with customer attachments
  duplicatedUploadFileTitle: string;
  duplicatedUploadFileNames: string[];

  /**
   * Create new instance.
   * @param commonService
   * @param notificationService
   * @param dialogRef The dialog reference.
   * @param dialog
   * @param message
   * @param data the displayed data.
   */
  constructor(
    public commonService: CommonService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<FileAttachComponent>,
    public dialog: MatDialog,
    private message: Message,
    @Inject(MAT_DIALOG_DATA) public data: {
      attachments: {
        id: number,
        fileSize: number,
        fileName: string,
        path: string,
        active: boolean
      }[],
      customerName: string,
      newUploadContractAttachments: []
    }
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
  }

  /**
   * On init.
   */
  ngOnInit() {
    // this.cloned = JSON.parse(JSON.stringify(this.data.attachments));
    if (this.data.newUploadContractAttachments != null && this.data.newUploadContractAttachments !== undefined) {
      this.newUploadContractAttachments = this.data.newUploadContractAttachments;
      this.initUploadFileSize = this.newUploadContractAttachments.length;
    } else {
      this.newUploadContractAttachments = null;
    }
  }

  /**
   * Click cancel.
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Click btn attach files
   */
  onAttachFile(): any {
    const dataFilter = this.data.attachments.filter(
      data => data.active);

    const dataNext = [];

    dataFilter.forEach(element => {
      dataNext.push(element);
    });

    return dataNext;
  }

  /**
   * roll back attach
   */
  rollBackAttach(): any[] {
    return this.cloned;
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (this.isFormChanging && this.show) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'Dữ liệu đang thay đổi sẽ bị mất. Bạn có muốn tiếp tục?'
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  checkboxChange(iAttach: number) {
    this.removeDuplicatedUploadError();

    var checkboxChangeSuccess = true;
    if (this.data.attachments[iAttach].active
          && this.isSelectAttachmentDuplicated(iAttach)) {
        checkboxChangeSuccess = false;
        this.uncheckAttachmentAndShowErrorDuplicate(iAttach);
    }

    if (checkboxChangeSuccess) this.isFormChanging = true;
  }

  /**
   * Uncheck checkbox by attachments's index then show error message
   * @param iAttach index of attachments list
   */
  uncheckAttachmentAndShowErrorDuplicate(iAttach) {
    setTimeout(_ => { this.data.attachments[iAttach].active = false })
    this.notificationService.notify(this.message.getMessage("validation.err_select_cust_file_duplicate_upload"));
  }

  /**
   * Check duplicate file name with new uploads
   */
  isSelectAttachmentDuplicated(iAttach: number): boolean {
    for (var i = 0; i < this.newUploadContractAttachments.length; i++)
      if (this.newUploadContractAttachments[i].name == this.data.attachments[iAttach].fileName) return true;

    return false;
  }

  /**
   * After new upload change, check and remove duplicated upload files which is
   * same name with selected customer's attachments
   * @param event isFromChange out from Upload Multiple Files Component
   */
  onNewUploadChange(event) {
    // Filter non-duplicated files and duplicated files
    var nonDuplicatedFiles: any[] = [];
    var duplicatedFiles: any[] = [];
    var selectedAttachments = this.data.attachments.filter(att => att.active);

    for (var iUpload = 0; iUpload < this.newUploadContractAttachments.length; iUpload++) {
      var isDuplicatedWithSelectedAttachment = false;
      var newUploadFile = this.newUploadContractAttachments[iUpload];

      for (var iAttach = 0; iAttach < selectedAttachments.length; iAttach++) {
        // Push upload file to  duplicatedFile.
        if (newUploadFile.name == selectedAttachments[iAttach].fileName) {
          duplicatedFiles.push(newUploadFile);
          isDuplicatedWithSelectedAttachment = true;
          break;
        }
      }

      // Push upload file to nonDuplicateFiles
      if (!isDuplicatedWithSelectedAttachment) {
        nonDuplicatedFiles.push(newUploadFile);
      }
    }

    // Keep nonDuplicated files only
    if (duplicatedFiles.length) {
      this.newUploadContractAttachments = nonDuplicatedFiles;
    }

    this.setErrorDuplicatedNewUploadsWithSelectedAttachments(duplicatedFiles);

    // Has changed if new upload files length is different with init one
    // or there is overried files in new upload
    if (nonDuplicatedFiles.length != this.initUploadFileSize || (this.uploadMultiFileComponent && this.uploadMultiFileComponent.hasOverride))
      this.isFormChanging = event;

    if (nonDuplicatedFiles.length != this.initUploadFileSize || (this.uploadMultiFileAttachmentsComponent && this.uploadMultiFileAttachmentsComponent.hasOverride)) this.isFormChanging = event;  
  }

  onClickUpload() {
    // Remove error message duplicate when click upload
    // Delay 500 milisecond to make the error disappear after open file show.
    this.removeDuplicatedUploadError(500);
  }

  setErrorDuplicatedNewUploadsWithSelectedAttachments(duplicatedFiles: any[]){
    if (this.uploadMultiFileComponent && !this.uploadMultiFileComponent.hasOverride && duplicatedFiles.length > 0) {
      // Set error title
      this.duplicatedUploadFileTitle = this.commonService.format(
        this.message.getMessage('validation.upload_file_duplicate_cust_file_title'), duplicatedFiles.length);
      // Set list duplicated files
      duplicatedFiles.forEach(file => {
        this.duplicatedUploadFileNames.push(file.name);
      });
    }

    if (this.uploadMultiFileAttachmentsComponent && !this.uploadMultiFileAttachmentsComponent.hasOverride && duplicatedFiles.length > 0) {
      // Set error title
      this.duplicatedUploadFileTitle = this.commonService.format(
        this.message.getMessage('validation.upload_file_duplicate_cust_file_title'), duplicatedFiles.length);
      // Set list duplicated files
      duplicatedFiles.forEach(file => {
        this.duplicatedUploadFileNames.push(file.name);
      });
    }
  }

  /**
   * Remove duplicate error message with some delay after upload
   * @param delay milisecond of setTimeout
   */
  removeDuplicatedUploadError(delay: number = 0) {
    setTimeout(_ => { this.duplicatedUploadFileNames = []; }, delay);
  }
}
